import { Component, Input } from '@angular/core';
import { iconGlyph, type IconName } from '../../../utils/icon-vocabulary';

/** Renders one vocabulary glyph. Stroke stays currentColor. */
@Component({
  selector: 'app-vocab-icon',
  template: `
    <span *ngIf="mark" class="tt-vocab-icon__mark">{{ mark }}</span>
    <svg
      *ngIf="!mark && (paths.length || spider)"
      class="w-4 h-4"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        *ngFor="let d of paths"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        [attr.d]="d"
      ></path>
      <ng-container *ngIf="spider">
        <line x1="12" y1="12" x2="5.5" y2="19.5" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="11" y2="20.5" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="16.5" y2="19.5" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="4.5" y2="7" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="14.5" y2="4" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="20.5" y2="9" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <line x1="12" y1="12" x2="20" y2="15.5" stroke-width="1.75" stroke-dasharray="2.2 1.8" stroke-linecap="round"></line>
        <circle cx="5.5" cy="19.5" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="11" cy="20.5" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="16.5" cy="19.5" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="4.5" cy="7" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="14.5" cy="4" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="20.5" cy="9" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="20" cy="15.5" r="1.15" fill="currentColor" stroke="none"></circle>
        <circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none"></circle>
      </ng-container>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: inherit;
      }
      .tt-vocab-icon__mark {
        font-size: 10px;
        font-weight: 700;
        letter-spacing: -0.02em;
        line-height: 1;
      }
    `,
  ],
})
export class VocabIconComponent {
  @Input() name: IconName | '' = '';

  get mark(): string {
    const glyph = iconGlyph(this.name);
    return glyph?.kind === 'mark' ? glyph.text : '';
  }

  get paths(): readonly string[] {
    const glyph = iconGlyph(this.name);
    return glyph?.kind === 'paths' ? glyph.paths : [];
  }

  get spider(): boolean {
    return iconGlyph(this.name)?.kind === 'spider';
  }
}
